import { AngularService } from '../angular-core';

// グローバルから参照
declare const $home_url: any;

/**
 * HTTPサービス
 */
@AngularService({
  name: 'httpService'
})
export class HttpService {

  /**
   * コンストラクタ
   */
  constructor(
    private readonly $http: any
  ) { }

  /**
   * 投稿情報にアクセス
   * @param params リクエストデータ
   * @returns HttpPromiseオブジェクト
   */
  public post(params: any): ng.IHttpPromise<any> {
    return this.$http({
      method: 'POST',
      url: $home_url,
      responseType: 'json',
      data: params
    });
  }

}
